import { useClassName } from '@/styles/CoverBox';
import { Component, ComponentProps } from '@/types/component';
import { withNonHTMLChildren, withSafeInnerHTML } from 'lib/utils';
import mergeProps from 'lib/utils/mergeProps';

export type CoverBoxHeadlineProps = ComponentProps<'h1'>;

export const CoverBoxHeadlineComponent: Component<CoverBoxHeadlineProps> = ({ children, ...props }) => {
  const className = useClassName('headline', props);

  return (
    <h1 {...withSafeInnerHTML(children)} {...mergeProps({ className }, props)}>
      {withNonHTMLChildren(children)}
    </h1>
  );
};
